module.exports = __webpack_public_path__ + "img/combinedmarker.510d3a70.svg";